<template>
  <!-- 进货管理 -->
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="进货入库">
        <IncomingStock></IncomingStock>
      </el-tab-pane>
      <el-tab-pane label="进货单据查询">
        <PurchaseList> </PurchaseList>
      </el-tab-pane>
      <el-tab-pane label="退货出库">
        <SalesReturn></SalesReturn>
      </el-tab-pane>
      <el-tab-pane label="退货单据查询">
        <CreditOrder></CreditOrder>
      </el-tab-pane>
      <el-tab-pane label="当前库存查询">
        <CurrentInventory></CurrentInventory>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CreditOrder from "./creditOrder.vue";
import CurrentInventory from "./currentInventory.vue";
import IncomingStock from "./IncomingStock.vue";
import PurchaseList from "./purchaseList.vue";
import SalesReturn from "./salesReturn.vue";
export default {
  name: "SlmsPurchase",
  components: {
    CreditOrder,
    CurrentInventory,
    IncomingStock,
    PurchaseList,
    SalesReturn,
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
